<astrea-internal-banner
    title="{{ 'pages.magazines.title' | translate }}"
></astrea-internal-banner>

<div class="astrea-doctrine p-sm-4 p-2">
    <div class="container">

        <div class="astrea-title mb-3">
            <p>
                {{ 'pages.magazines.text1' | translate }}
                <a href="https://www.astreavirtual.com" target="_blank" title="Astrea Virtual">Astrea Virtual</a>.
            </p>
        </div>

        <div *ngIf="!loading; else astreaLoading">

            <div *ngIf="magazines && magazines.length > 0; else withoutResults" id="magazines" class="d-flex j-c-around flex-wrap">
                <astrea-magazines-details
                    *ngFor="let m of magazines"
                    [magazine]="m"
                    class="animated astreaFade"
                ></astrea-magazines-details>
            </div>

            <ng-template #withoutResults>
                <div class="t-center">
                    {{ 'pages.magazines.without' | translate }}
                </div>
            </ng-template>

            <div>
                <astrea-paginator
                    [itemsPerPage]="itemsPerPage"
                    [totalLength]="totalLength"
                    [pageRedirect]="'/articles'"
                ></astrea-paginator>
            </div>

        </div>

        <ng-template #astreaLoading>
            <astrea-loading
                [text]="'pages.magazines.loading' | translate"
            ></astrea-loading>
        </ng-template>

    </div>
</div>
